import InstitutionDetails from "../model/InstitutionDetails";

const InstitutionDetailsMapper = (item: any) => {
  let courtCase = InstitutionDetails(item);
  return courtCase;
};

export default InstitutionDetailsMapper;
